const STORAGE_KEY = 'campaigns::completed'

type CampaignsStorage = Record<string, string[]>

export function getCompletedCampaigns() {
  try {
    const storedCampaigns = localStorage.getItem(STORAGE_KEY)

    return JSON.parse(storedCampaigns || '{}') as CampaignsStorage
  } catch {
    return {}
  }
}

export function setCompletedCampaign(subjectId: string, campaign: string) {
  const campaigns = getCompletedCampaigns()

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...campaigns,
        [subjectId]: [...(campaigns[subjectId] || []), campaign]
      })
    )
  } catch {
    console.error('Error setting completed campaign')
  }
}

export function hasCompletedCampaign(subjectId: string, campaign: string) {
  const campaigns = getCompletedCampaigns()

  return !!campaigns[subjectId]?.includes(campaign)
}
